// extracted by mini-css-extract-plugin
export var container = "WrapperTwoCol-module--container--EWmQZ";